declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>
  }
}

export function trackEvent(event: string, params?: Record<string, any>) {
  if (window.dataLayer) {
    window.dataLayer.push({ event, ...params })
  }
}

export const analytics = {
  qrPageView: (schoolSku: string, schoolName: string) =>
    trackEvent('qr_page_view', { school_sku: schoolSku, school_name: schoolName }),

  appStoreClick: (platform: 'ios' | 'android', schoolSku: string) =>
    trackEvent('app_store_click', { platform, school_sku: schoolSku }),

  webappClick: (schoolSku: string) =>
    trackEvent('webapp_click', { school_sku: schoolSku }),

  openSchoolClick: (schoolSku: string) =>
    trackEvent('open_school_click', { school_sku: schoolSku }),
}
